// import React, { useState, useEffect } from "react";
// import ClientNavbar from "../layout/ClientNavbar";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";

// export default function ClienResearchAnalyst() {
//   const [searchQuery, setSearchQuery] = useState("");
//   const [showReport, setShowReport] = useState(false);
//   const [activeTab, setActiveTab] = useState("industry");
//   const [blurReport, setBlurReport] = useState(false);

//   // Mock report data
//   const mockReport = {
//     name: "Reliance Industries Ltd",
//     currentPrice: "2,500",
//     high52Week: "2,700",
//     low52Week: "1,900",
//     marketCap: "15,00,000 Cr",
//     peRatio: "28",
//     dividendYield: "0.5%",
//     researchSummary:
//       "Reliance Industries Ltd. shows strong fundamentals with steady revenue growth. Key sectors include energy, telecom, and retail.",
//   };

//   const chartData = [
//     { month: "Jan", price: 2100 },
//     { month: "Feb", price: 2200 },
//     { month: "Mar", price: 2000 },
//     { month: "Apr", price: 2300 },
//     { month: "May", price: 2400 },
//     { month: "Jun", price: 2500 },
//     { month: "Jul", price: 2450 },
//     { month: "Aug", price: 2600 },
//     { month: "Sep", price: 2550 },
//   ];

//   const handleSearch = () => {
//     if (searchQuery.trim() !== "") {
//       setShowReport(true);
//     }
//   };

//   // Disable copy, right-click, detect PrintScreen
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       // Disable PrintScreen key
//       if (e.key === "PrintScreen") {
//         setBlurReport(true);
//         navigator.clipboard.writeText(""); // Clear clipboard
//         setTimeout(() => setBlurReport(false), 1500); // unblur after 1.5s
//         alert("Screenshots are disabled on this page!");
//       }

//       // Disable Ctrl+C
//       if (e.ctrlKey && (e.key === "c" || e.key === "C")) {
//         e.preventDefault();
//       }
//     };

//     const handleContextMenu = (e) => e.preventDefault();

//     document.addEventListener("keydown", handleKeyDown);
//     document.addEventListener("contextmenu", handleContextMenu);

//     return () => {
//       document.removeEventListener("keydown", handleKeyDown);
//       document.removeEventListener("contextmenu", handleContextMenu);
//     };
//   }, []);

//   return (
//     <div
//       className="container-fluid"
//       style={{
//         userSelect: "none", // disable text selection
//       }}
//     >
//       <div className="row min-vh-100">
//         <div className="col-md-2 p-0">
//           <ClientNavbar />
//         </div>

//         <div
//           className="col-md-10 py-5 px-4"
//           style={{
//             background:
//               "linear-gradient(135deg, rgb(240, 253, 253) 0%, rgba(155, 222, 218, 0.73) 50%, rgb(3, 186, 187) 100%)",
//             minHeight: "100vh",
//           }}
//         >
//           <div className="card shadow-sm p-4" style={{ borderRadius: "16px" }}>
//             <h4 className="fw-bold mb-4">Research & Analysis (RA)</h4>

//             {/* Tabs */}
//             <ul className="nav nav-tabs mb-4">
//               {["industry", "domestic", "global", "stock"].map((tab) => (
//                 <li className="nav-item" key={tab}>
//                   <button
//                     className={`nav-link ${activeTab === tab ? "active" : ""}`}
//                     onClick={() => {
//                       setActiveTab(tab);
//                       setShowReport(false);
//                       setSearchQuery("");
//                     }}
//                   >
//                     {tab === "industry" && "Industrial View"}
//                     {tab === "domestic" && "Domestic Economy"}
//                     {tab === "global" && "Global Economy"}
//                     {tab === "stock" && "Stock Research"}
//                   </button>
//                 </li>
//               ))}
//             </ul>

//             {/* Tab Content */}
//             {["industry", "domestic", "global", "stock"].includes(activeTab) && (
//               <div className="card shadow-sm p-4">
//                 <h5 className="fw-bold">
//                   {activeTab === "industry" && "Industrial View"}
//                   {activeTab === "domestic" && "Domestic Economy"}
//                   {activeTab === "global" && "Global Economy"}
//                   {activeTab === "stock" && "Stock Research"}
//                 </h5>

//                 {/* Search Bar */}
//                 <div className="d-flex mb-4">
//                   <input
//                     type="text"
//                     className="form-control me-2"
//                     placeholder={`Search ${activeTab} by name...`}
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                   />
//                   <button className="btn btn-primary" onClick={handleSearch}>
//                     Search
//                   </button>
//                 </div>

//                 {/* Report */}
//                 {showReport && (
//                   <div
//                     className="card shadow-sm p-4"
//                     style={{
//                       filter: blurReport ? "blur(8px)" : "none",
//                       transition: "filter 0.3s",
//                     }}
//                   >
//                     <h5 className="fw-semibold mb-3">{mockReport.name}</h5>

//                     <div className="row">
//                       <div className="col-md-4">
//                         <p>
//                           <strong>Current Price:</strong> ₹{mockReport.currentPrice}
//                         </p>
//                         <p>
//                           <strong>52-Week High:</strong> ₹{mockReport.high52Week}
//                         </p>
//                         <p>
//                           <strong>52-Week Low:</strong> ₹{mockReport.low52Week}
//                         </p>
//                       </div>
//                       <div className="col-md-4">
//                         <p>
//                           <strong>Market Cap:</strong> {mockReport.marketCap}
//                         </p>
//                         <p>
//                           <strong>P/E Ratio:</strong> {mockReport.peRatio}
//                         </p>
//                         <p>
//                           <strong>Dividend Yield:</strong> {mockReport.dividendYield}
//                         </p>
//                       </div>
//                     </div>

//                     {/* Chart */}
//                     <div className="mt-4">
//                       <h6 className="fw-semibold">📊 Price Trend (Last 9 months)</h6>
//                       <ResponsiveContainer width="100%" height={300}>
//                         <LineChart data={chartData}>
//                           <CartesianGrid strokeDasharray="3 3" />
//                           <XAxis dataKey="month" />
//                           <YAxis />
//                           <Tooltip />
//                           <Line
//                             type="monotone"
//                             dataKey="price"
//                             stroke="#007bff"
//                             strokeWidth={2}
//                             dot={{ r: 4 }}
//                           />
//                         </LineChart>
//                       </ResponsiveContainer>
//                     </div>

//                     {/* Research Summary */}
//                     <div className="mt-4">
//                       <h6 className="fw-semibold">Research Summary:</h6>
//                       <p className="text-muted">{mockReport.researchSummary}</p>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { NavLink } from "react-router-dom";

export default function ClienResearchAnalyst() {
  const [searchQuery, setSearchQuery] = useState("");
  const [showReport, setShowReport] = useState(false);
  const [activeTab, setActiveTab] = useState("industry");
  const [blurReport, setBlurReport] = useState(false);

  const mockReport = {
    name: "Reliance Industries Ltd",
    currentPrice: "2,500",
    high52Week: "2,700",
    low52Week: "1,900",
    marketCap: "15,00,000 Cr",
    peRatio: "28",
    dividendYield: "0.5%",
    researchSummary:
      "Reliance Industries Ltd. shows strong fundamentals with steady revenue growth. Key sectors include energy, telecom, and retail.",
  };

  const chartData = [
    { month: "Jan", price: 2100 },
    { month: "Feb", price: 2200 },
    { month: "Mar", price: 2000 },
    { month: "Apr", price: 2300 },
    { month: "May", price: 2400 },
    { month: "Jun", price: 2500 },
    { month: "Jul", price: 2450 },
    { month: "Aug", price: 2600 },
    { month: "Sep", price: 2550 },
  ];

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "PrintScreen") {
        setBlurReport(true);
        try {
          navigator.clipboard.writeText("");
        } catch (err) {}
        setTimeout(() => setBlurReport(false), 1500);
        alert("Screenshots are disabled on this page!");
      }
      if (e.ctrlKey && (e.key === "c" || e.key === "C")) e.preventDefault();
    };
    const handleContextMenu = (e) => e.preventDefault();

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("contextmenu", handleContextMenu);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setShowReport(false);
    }
  }, [searchQuery]);

  const tabs = [
    { id: "industry", label: "Industrial View" },
    { id: "domestic", label: "Domestic Economy" },
    { id: "global", label: "Global Economy" },
    { id: "stock", label: "Stock Research" },
  ];

  const handleSearch = () => {
    if (searchQuery.trim() === "") {
      setShowReport(false);
      return;
    }
    setShowReport(true);
  };

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9", userSelect: "none" }}>
         
          <div className="ra-shell">
             <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Research &amp; Analysis (RA)</h3>
            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Research &amp; Analysis (RA)
                </li>
              </ol>
            </nav>
            </div>

            <div
              className="ra-tabs-container"
              role="tablist"
              aria-label="RA Tabs"
            >
              <div className="ra-tabs-grid">
                {tabs.map((t) => (
                  <button
                    key={t.id}
                    role="tab"
                    aria-selected={activeTab === t.id}
                    className={`ra-tab ${activeTab === t.id ? "active" : ""}`}
                    onClick={() => {
                      setActiveTab(t.id);
                      setShowReport(false);
                      setSearchQuery("");
                    }}
                  >
                    {t.label}
                  </button>
                ))}
              </div>
            </div>

            <div className="ra-panel card p-4 mt-4">
              <h5 className="fw-bold mb-3">
                {activeTab === "industry" && "Industrial View"}
                {activeTab === "domestic" && "Domestic Economy"}
                {activeTab === "global" && "Global Economy"}
                {activeTab === "stock" && "Stock Research"}
              </h5>

              <div className="d-flex flex-wrap gap-2 mb-4">
                <input
                  type="text"
                  className="form-control ra-search-input"
                  placeholder={`Search ${activeTab} by name...`}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />

                <button className="btn ra-search-btn" onClick={handleSearch}>
                  Search
                </button>
              </div>

              {showReport && (
                <div
                  className="card p-4"
                  style={{
                    filter: blurReport ? "blur(8px)" : "none",
                    transition: "filter .3s",
                  }}
                >
                  <h5 className="mb-3">{mockReport.name}</h5>

                  <div className="row">
                    <div className="col-12 col-md-4">
                      <p>
                        <strong>Current Price:</strong> ₹
                        {mockReport.currentPrice}
                      </p>
                      <p>
                        <strong>52-Week High:</strong> ₹{mockReport.high52Week}
                      </p>
                      <p>
                        <strong>52-Week Low:</strong> ₹{mockReport.low52Week}
                      </p>
                    </div>

                    <div className="col-12 col-md-4">
                      <p>
                        <strong>Market Cap:</strong> {mockReport.marketCap}
                      </p>
                      <p>
                        <strong>P/E Ratio:</strong> {mockReport.peRatio}
                      </p>
                      <p>
                        <strong>Dividend Yield:</strong>{" "}
                        {mockReport.dividendYield}
                      </p>
                    </div>
                  </div>

                  <div className="mt-4">
                    <h6>📊 Price Trend (Last 9 months)</h6>
                    <ResponsiveContainer width="100%" height={260}>
                      <LineChart data={chartData}>
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="month" />
                        <YAxis />
                        <Tooltip />
                        <Line
                          type="monotone"
                          dataKey="price"
                          stroke="#06c6b5"
                          strokeWidth={2}
                          dot={{ r: 3 }}
                        />
                      </LineChart>
                    </ResponsiveContainer>
                  </div>

                  <div className="mt-4">
                    <h6>Research Summary:</h6>
                    <p className="text-muted">{mockReport.researchSummary}</p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
  
    </>
  );
}
